import Router from "./deployments-router";

import DeploymentsComponent from "./deployments-component";
import DeploymentListComponent from "./deployment-list/deployment-list.component";
import DeploymentUpdateComponent from "./deployment-update/deployment-update.component";
import DeploymentSettingComponent from "./deployment-setting/deployment-setting.component";

const Module = angular
    .module("app.deployments", [])
    .component("deployments", DeploymentsComponent)
    .component("deploymentList", DeploymentListComponent)
    .component("deploymentUpdate", DeploymentUpdateComponent)
    .component("deploymentSetting", DeploymentSettingComponent)
    .config(Router);

export default Module;


// WEBPACK FOOTER //
// ./sources/components/deployments/deployments-module.js